import { render, staticRenderFns } from "./IssueActions.vue?vue&type=template&id=7bdd9b6e"
import script from "./IssueActions.vue?vue&type=script&lang=js"
export * from "./IssueActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports